<template>
  <div class="print-wrapper">
    <!-- 产品信息表格 -->
    <table class="info-table">
      <tbody>
        <tr>
          <td class="info-label">产品编号</td>
          <td class="info-value"></td>
          <td class="info-label">产品属性</td>
          <td class="info-value"></td>
          <td rowspan="4" class="product-image">
            <e-upload-image
              v-if="data.tableSaleData[0].list_chan_pin_tu"
              :list.sync="data.tableSaleData[0].list_chan_pin_tu"
              size="80px"
              disabled
            />
          </td>
        </tr>
        <tr>
          <td class="info-label">产品名称</td>
          <td class="info-value">{{ data.tableSaleData[0].name }}</td>
          <td class="info-label">单位</td>
          <td class="info-value">{{ data.tableSaleData[0].unit }}</td>
        </tr>
        <tr>
          <td class="info-label">产品规格</td>
          <td class="info-value">{{ data.tableSaleData[0].spec }}</td>
          <td class="info-label">数量</td>
          <td class="info-value">{{ data.tableSaleData[0].counts }}</td>
        </tr>
        <tr>
          <td class="info-label">备注</td>
          <td colspan="3" class="info-value">{{ data.tableSaleData[0].remark }}</td>
        </tr>
      </tbody>
    </table>

    <!-- 物料清单表格 -->
    <table class="material-table">
      <thead>
        <tr>
          <th colspan="6" class="table-title">物料清单</th>
        </tr>
        <tr>
          <th width="80">序号</th>
          <th>物料名称</th>
          <th>规格</th>
          <th>单位</th>
          <th>数量</th>
          <th width="80">备注</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in wuliaoData" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.spec }}</td>
          <td>{{ item.unit }}</td>
          <td>{{ item.counts }}</td>
          <td>{{ item.remark }}</td>
        </tr>
      </tbody>
    </table>

    <!-- 工艺路线表格 -->
    <table class="process-table">
      <tbody>
        <tr>
          <td class="process-label">工艺路线</td>
          <td class="process-content">
            <div class="process-flex">
              <div
                v-for="(item, index) in data.tableSaleData[0].table_data_3"
                :key="index"
                :class="['process-step', { active: item.id === data.gongyiData.jia_gong_id }]"
              >
                <span class="step-circle">{{ index + 1 }}</span>
                <span class="step-name">{{ item.name }}</span>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 物料采购表格 -->
    <table class="purchase-table">
      <tbody>
        <tr>
          <th width="80">上一工序</th>
          <th colspan="7">当前工序({{ data.gongyiData.name }})</th>
          <th width="80">下一工序</th>
        </tr>
        <tr>
          <td rowspan="2">{{ data.formData.prev_gongxu_name }}</td>
          <th>名称</th>
          <th>规格</th>
          <th>单位</th>
          <th>数量</th>
          <th>领料数</th>
          <th>报工数</th>
          <th>仓位</th>
          <td rowspan="2">{{ data.formData.next_gongxu_name }}</td>
        </tr>
        <tr v-for="(item, index) in [data.gongyiData]" :key="index">
          <td>{{ item.name }}</td>
          <td>{{ item.spec }}</td>
          <td>{{ item.unit }}</td>
          <td>{{ item.counts }}</td>
          <td>{{ item.issuedQty }}</td>
          <td>{{ item.reportedQty }}</td>
          <td>{{ item.location }}</td>
        </tr>
      </tbody>
    </table>

    <!-- 质检要求表格 -->
    <table class="inspection-table">
      <thead>
        <tr>
          <th colspan="5">质检要求</th>
        </tr>
        <tr>
          <th>序号</th>
          <th>检测项目</th>
          <th>标准范围</th>
          <th>实测范围</th>
          <th>检测结果</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="index in 5" :key="index">
          <td>{{ index }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'PrintTable',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      wuliaoData: []
    }
  },
  mounted() {
    this.initTableData()
  },
  methods: {
    initTableData() {
      let data = this.data.tableSaleData[0] || {}
      if (data.tableBomData.length) {
        this.wuliaoData = data.tableBomData || []
        return
      }
      if (data.table_data_2.length) {
        this.wuliaoData = data.table_data_2 || []
        return
      }
      this.wuliaoData = data.table_data_1 || []
    }
  }
}
</script>

<style lang="less" scoped>
.print-wrapper {
}

// 产品信息表格
.info-table {
  width: 100%;
  border-collapse: collapse;

  td {
    border: 1px solid #000;
    padding: 4px;
    font-size: 12px;
  }

  .info-label {
    width: 80px;
    background: #e0e5eb;
    text-align: center;
    font-weight: bold;
  }

  .info-value {
    min-width: 100px;
  }

  .product-image {
    width: 80px;
    text-align: center;
    vertical-align: middle;

    img {
      max-width: 140px;
      max-height: 140px;
      object-fit: contain;
    }
  }
}

// 物料清单表格
.material-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: -1px;

  th,
  td {
    border: 1px solid #000;
    padding: 4px;
    font-size: 12px;
    text-align: center;
  }

  th {
    font-weight: bold;
    background: #e0e5eb;
  }

  .table-title {
    text-align: center;
    background: #e0e5eb;
  }
}

// 工艺路线表格
.process-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: -1px;

  td {
    border: 1px solid #000;
    padding: 4px;
    font-size: 12px;
  }

  .process-label {
    width: 80px;
    background: #e0e5eb;
    text-align: center;
    font-weight: bold;
  }

  .process-content {
    .process-flex {
      display: flex;
      align-items: center;
      gap: 4px;
      flex-wrap: wrap;
    }
  }

  .process-step {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    background: #eee;
    border-radius: 4px;

    &.active {
      background: @colorRed;
      color: #fff;

      .step-circle {
        background: #fff;
        color: @colorRed;
      }
    }

    .step-circle {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: #bbb;
      color: #333;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 10px;
      font-weight: bold;
    }

    .step-name {
      font-size: 12px;
    }
  }
}

// 物料采购表格
.purchase-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: -1px;

  th,
  td {
    border: 1px solid #000;
    padding: 4px;
    font-size: 12px;
    text-align: center;
  }

  th {
    font-weight: bold;
    background: #e0e5eb;
  }
}

// 质检要求表格
.inspection-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: -1px;

  th,
  td {
    border: 1px solid #000;
    padding: 4px;
    font-size: 12px;
    text-align: center;
  }

  th {
    font-weight: bold;
    background: #e0e5eb;
  }

  .table-title {
    text-align: left;
    background: #e0e5eb;
  }
}
</style>
